import SimpleDataWithVariation from '@/language/en/components/cards/models/SimpleDataWithVariation';
import CardWithTitle from '@/language/en/components/cards/models/CardWithTitle';
import PieChart from '@/language/en/components/cards/models/PieChart';
import TogglePieChart from '@/language/en/components/cards/models/TogglePieChart';
import BubbleChart from '@/language/en/components/cards/models/BubbleChart';
import CardChart from '@/language/en/components/cards/models/CardChart';
import InputController from '@/language/en/components/cards/models/InputController';
import LineChart from '@/language/en/components/cards/models/LineChart';
import TermGraph from '@/language/en/components/cards/models/TermGraph';
import Feed from '@/language/en/components/cards/models/Feed';
import CustomLineChart from '@/language/en/components/cards/models/CustomLineChart';
import CardOptions from '@/language/en/components/cards/models/CardOptions';

export default {
  SimpleDataWithVariation,
  CardWithTitle,
  PieChart,
  TogglePieChart,
  BubbleChart,
  CardChart,
  InputController,
  LineChart,
  TermGraph,
  Feed,
  CustomLineChart,
  CardOptions,
};
